import {useMatches} from '@github-ui/react-router'

import {codeViewBlameRoute} from '../routes/code-view-blame-route'
import {codeViewBlobRoute} from '../routes/code-view-blob-route'
import {codeViewDeleteRoute} from '../routes/code-view-delete-route'
import {codeViewEditRoute} from '../routes/code-view-edit-route'
import {codeViewNewRoute} from '../routes/code-view-new-route'
import {codeViewTreeDeleteRoute} from '../routes/code-view-tree-delete-route'

export function useIsFilePage() {
  const matches = useMatches()

  return matches.some(
    match =>
      match.id === codeViewBlameRoute.id ||
      match.id === codeViewBlobRoute.id ||
      match.id === codeViewDeleteRoute.id ||
      match.id === codeViewEditRoute.id ||
      match.id === codeViewNewRoute.id ||
      match.id === codeViewTreeDeleteRoute.id,
  )
}
